import type { ChatSourcePosition, ChatSourceRect } from '@libertify/ui';

/** Zone position as the backend sends it — `MessageOrigin` and `SourceZone`
 *  declare it separately but identically, so both feed this adapter. */
export interface RawSourcePosition {
  page_number: number;
  bounding_rect?: ChatSourceRect | null;
  rects?: unknown[];
}

/** Undefined when the zone has no bounding rect — no precise scroll target,
 *  only a document to switch to. */
export const toChatSourcePosition = (
  position: RawSourcePosition | null | undefined,
): ChatSourcePosition | undefined => {
  if (!position?.bounding_rect) return undefined;
  return {
    pageNumber: position.page_number ?? 0,
    boundingRect: position.bounding_rect,
    rects: (position.rects ?? []) as ChatSourceRect[],
  };
};
